module.exports = __webpack_public_path__ + "web_static/img/spaces_background.dbcd95c1.png";